export const TTS_ENGINES = {
    BROWSER: 'browser',
    EDGE: 'edge',
    PIPER: 'piper'
};

export const DEFAULT_LOCALE = 'en-GB';
